import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.amaxPayment.FailPage', {
    title: 'Amax Payment | Fail',
    learnMore: 'Learn more',
    unableToConfirm: 'Unable to confirm the payment',
    thereWasAnIssue: 'Oops, there was an issue confirming the payment.',
    retry: 'Try again',
    contactSupport: 'Contact Support',
    areYouSure: 'Are you sure you want to close this window?',
    yes: 'Yes, Close It',
});
